import React, { useState, useEffect, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { setBreadcrumps } from "../../../actions";
import {
  makeStyles,
  TextField,
  Button,
  Grid,
  Typography,
  Paper,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import Swal from "sweetalert2";
import Header from "../../../components/Header";
import Backdrop from "../../../components/Backdrop";
import axios from "../../../api";
import { decrypt } from "../../../utils/crypt";
import { useParams } from "react-router-dom";
import {
  ColumnDirective,
  ColumnsDirective,
  GridComponent,
  Inject,
  Search,
  Page,
  Sort,
  Filter,
  ExcelExport,
  Toolbar,
} from "@syncfusion/ej2-react-grids";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

function FormGradeGroups(props) {
  const { setBreadcrumps, userId, rawPermissions, token } = props;
  const params = useParams();
  const classes = useStyles();
  const [assignedStudents, setAssignedStudents] = useState([]);
  const [assignedTeachers, setAssignedTeachers] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const [periods, setPeriods] = useState([]);
  const [grades, setGrades] = useState([]);
  const isMounted = useRef(true);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  const history = useNavigate();
  const [loading, setLoading] = useState(false);
  const [loadingDetail, setLoadingDetail] = useState(false);
  const [page, setPage] = useState(0);
  const [totalStudents, setTotalStudents] = useState(0);
  const rowsPerPage = 20;

  const [form, setForm] = useState({
    nombre: "",
    es_virtual: "",
    id_materias: "",
    id_docentes: "",
    pensum: "",
    id_periodos: "", // Global group period
    id_estudiantes: "",
    modal_period: "", // New: specific for student modal
    id_docentes_list: "",
    id_periodos_docentes: "",
  });

  const [openModalTeacher, setOpenModalTeacher] = useState(false);
  const [openModalStudent, setOpenModalStudent] = useState(false);
  const [modalTarget, setModalTarget] = useState("student");
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  const deleteButton = (row) => {
    const modalDelete = (data) => {
      Swal.fire({
        text: "¿Está seguro que desea eliminar a este estudiante?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#9d2d39",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then(async (result) => {
        if (result.value) {
          setAssignedStudents((prev) => prev.filter((e) => e.usuario?.id !== data.usuario?.id));
          Swal.fire({ text: "Eliminado exitosamente.", icon: "success", showConfirmButton: false, timer: 2000 });
        }
      });
    };

    return (
      <Button onClick={() => modalDelete(row)} style={{ backgroundColor: "#9d2d39", color: "white" }}>
        Eliminar
      </Button>
    );
  };

  const deleteButtonTeacher = (row) => {
    const modalDelete = (data) => {
      Swal.fire({
        text: "¿Está seguro que desea eliminar a este docente?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#9d2d39",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then(async (result) => {
        if (result.value) {
          setAssignedTeachers((prev) => prev.filter((e) => e.usuario?.id !== data.usuario?.id));
          Swal.fire({ text: "Eliminado exitosamente.", icon: "success", showConfirmButton: false, timer: 2000 });
        }
      });
    };

    return (
      <Button onClick={() => modalDelete(row)} style={{ backgroundColor: "#9d2d39", color: "white" }}>
        Eliminar
      </Button>
    );
  };

  const columnsTeachers = useMemo(() => [
    { field: "usuario.nombres", headerText: "Nombres", width: "150" },
    { field: "usuario.apellidos", headerText: "Apellidos", width: "150" },
    { field: "periodo.nombre", headerText: "Periodo", width: "120" },
    { headerText: "Eliminar", template: deleteButtonTeacher, width: "120", textAlign: "Center" }
  ], []);

  const columnsStudents = useMemo(() => [
    { field: "usuario.nombres", headerText: "Nombres", width: "150" },
    { field: "usuario.apellidos", headerText: "Apellidos", width: "150" },
    { field: "periodo.nombre", headerText: "Periodo", width: "120" },
    { headerText: "Eliminar", template: deleteButton, width: "120", textAlign: "Center" }
  ], []);

  const permission = useMemo(() => (
    (rawPermissions || [])
      .filter((data) => data.modulosAcciones?.id_modulos === 15)
      .map((item) => item.modulosAcciones?.id_acciones)
  ), [rawPermissions]);

  useEffect(() => {
    if (Array.isArray(rawPermissions) && rawPermissions.length > 0) {
      if (permission.includes(2) || permission.includes(3)) {
        if (periods.length === 0) fetchInitialData();
        if (params.id && assignedStudents.length === 0 && !loadingDetail) getGroup();
      } else {
        history("/");
      }
    }
  }, [rawPermissions, params.id, permission]);

  const getGroup = async () => {
    if (!params.id) return;
    try {
      setLoadingDetail(true);
      const id = decrypt(params.id);
      const res = await axios.get(`/gradeGroup/${id}?page=${page + 1}&limit=${rowsPerPage}`, {
        headers: { "access-token": token },
      });

      const groupData = res.data?.data || res.data?.gradeGroup;
      if (groupData && isMounted.current) {
        setAssignedStudents(res.data?.students || groupData.estudiantes || []);
        setAssignedTeachers(res.data?.teachers || groupData.docentes || []);
        setTotalStudents(res.data?.total || groupData.totalEstudiantes || 0);

        if (groupData.docente) setTeachers([groupData.docente]);
        if (groupData.materias) setGrades([groupData.materias]);

        setForm({
          ...groupData,
          id_estudiantes: "",
          id_docentes_list: "",
          id_periodos_docentes: "",
          modal_period: "", 
          materia_object: groupData.materias || null,
          docente_object: groupData.docente || null,
        });
      }
    } catch (error) {
      console.error("Error fetching group:", error);
    } finally {
      if (isMounted.current) setLoadingDetail(false);
    }
  };

  const fetchInitialData = async () => {
    try {
      const { data: periodData } = await axios.post("/period/getPeriods", {}, {
        headers: { "access-token": token },
      });
      if (periodData?.success) setPeriods(periodData.periods || []);
    } catch (error) {
      console.error("Error al cargar datos iniciales:", error);
    }
  };

  const searchUsers = async (search, groupId, setter) => {
    const trimmedSearch = (search || "").trim();
    if (trimmedSearch.length <= 2) return setter([]);
    try {
      const { data } = await axios.post(`/user/getUsers`, { search: trimmedSearch, id_grupos_usuarios: groupId, limit: 10 }, {
        headers: { "access-token": token },
      });
      setter(data?.users || []);
    } catch (error) {
       console.error("Error searching users:", error);
    }
  };

  const addAssignedStudent = (e) => {
    e.preventDefault();
    const student = form.student_selected;
    const period = periods.find((p) => p.id === form.modal_period);
    if (!student || !period) return;
    setAssignedStudents((prev) => [...prev, { usuario: student, periodo: period, id_usuarios: student.id, id_periodos: period.id }]);
    setForm({ ...form, id_estudiantes: "", modal_period: "", student_selected: null });
  };

  const addAssignedTeacher = (e) => {
    e.preventDefault();
    const teacher = form.teacher_selected;
    const period = periods.find((p) => p.id === form.id_periodos_docentes);
    if (!teacher || !period) return;
    setAssignedTeachers((prev) => [...prev, { usuario: teacher, periodo: period, id_usuarios: teacher.id, id_periodos: period.id }]);
    setForm({ ...form, id_docentes_list: "", id_periodos_docentes: "", teacher_selected: null });
  };

  const handleSave = async () => {
    if (!form.nombre || !form.id_materias || !form.id_docentes) {
       return Swal.fire({ text: "Por favor complete los campos obligatorios", icon: "warning" });
    }
    setLoading(true);
    try {
      // Limpiar payload para enviar solo lo necesario
      const { 
        materia_object, 
        docente_object, 
        student_selected, 
        teacher_selected, 
        modal_period,
        id_estudiantes,
        id_docentes_list,
        id_periodos_docentes,
        docente,
        materias,
        estudiantes: oldEstudiantes,
        docentes: oldDocentes,
        ...restForm 
      } = form;

      const payload = {
        ...restForm,
        estudiantes: assignedStudents.map(s => ({ 
          id_usuarios: s.usuario?.id || s.id_usuarios, 
          id_periodos: s.periodo?.id || s.id_periodos 
        })),
        docentes: assignedTeachers.map(t => ({ 
          id_usuarios: t.usuario?.id || t.id_usuarios, 
          id_periodos: t.periodo?.id || t.id_periodos 
        })),
      };

      // Si id_periodos es vacío, intentar tomarlo del primer estudiante asignado
      if (!payload.id_periodos && payload.estudiantes.length > 0) {
        payload.id_periodos = payload.estudiantes[0].id_periodos;
      }

      const response = params.id 
        ? await axios.put(`/gradeGroup/${decrypt(params.id)}`, payload, { headers: { "access-token": token } })
        : await axios.post("/gradeGroup/create", payload, { headers: { "access-token": token } });

      // Si axios no lanza excepción, fue exitoso (status 200)
      if (response.status === 200 || response.status === 201) {
        Swal.fire({ 
          title: "¡Éxito!", 
          text: "Grupo Materia guardado correctamente", 
          icon: "success", 
          timer: 2000, 
          showConfirmButton: false 
        });
        history("/gradeGroups");
      } else if (response.data?.success) {
        // Fallback en caso de que lo necesite
        Swal.fire({ text: "Guardado exitosamente", icon: "success", timer: 2000, showConfirmButton: false });
        history("/gradeGroups");
      }
    } catch (error) {
       console.error("Error saving:", error);
       const errorMsg = error.response?.data?.message || "Ocurrió un error al guardar o actualizar los datos.";
       Swal.fire({ 
         title: "¡Error!", 
         text: errorMsg, 
         icon: "error" 
       });
    } finally {
      if (isMounted.current) setLoading(false);
    }
  };

  if (!Array.isArray(rawPermissions) || rawPermissions.length === 0) {
     return <div className="p-10 text-center"><Backdrop loading={true} />Cargando...</div>;
  }

  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl">
      <Header category="Gestión" title={params.id ? "Editar Grupo" : "Crear Grupo"} />
      <Paper elevation={3} className={classes.paper}>
        <Grid container spacing={4} className={classes.container}>
          <Grid item xs={12}><Typography className={classes.sectionTitle}>Información Básica</Typography></Grid>
          <Grid item xs={12} sm={6}>
            <TextField label="Nombre del Grupo" fullWidth variant="outlined" value={form.nombre} onChange={(e) => setForm({ ...form, nombre: e.target.value })} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel>¿Es Virtual?</InputLabel>
              <Select value={form.es_virtual} onChange={(e) => setForm({ ...form, es_virtual: e.target.value })} label="¿Es Virtual?">
                <MenuItem value={1}>Sí</MenuItem>
                <MenuItem value={0}>No</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <Autocomplete
              options={grades}
              getOptionLabel={(o) => `${o.codigo} - ${o.nombre}`}
              renderInput={(p) => <TextField {...p} label="Buscar Materia" variant="outlined" />}
              onInputChange={(e, v) => searchUsers(v, null, setGrades)}
              onChange={(e, v) => setForm({ ...form, id_materias: v?.id || "" })}
              value={form.materia_object}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <Autocomplete
              options={teachers}
              getOptionLabel={(o) => `${o.nombres} ${o.apellidos}`}
              renderInput={(p) => <TextField {...p} label="Docente Principal" variant="outlined" />}
              onInputChange={(e, v) => searchUsers(v, 4, setTeachers)}
              onChange={(e, v) => setForm({ ...form, id_docentes: v?.id || "" })}
              value={form.docente_object}
            />
          </Grid>

          <Grid item xs={12} sm={12}>
            <TextField label="Pensum" fullWidth variant="outlined" value={form.pensum} onChange={(e) => setForm({ ...form, pensum: e.target.value })} />
          </Grid>

          <Grid item xs={12} sm={12}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel>Periodo del Grupo</InputLabel>
              <Select value={form.id_periodos} onChange={(e) => setForm({ ...form, id_periodos: e.target.value })} label="Periodo del Grupo">
                {periods.map(p => <MenuItem key={p.id} value={p.id}>{p.nombre}</MenuItem>)}
              </Select>
            </FormControl>
          </Grid>

          <Divider style={{ width: "100%", margin: "20px 0" }} />
          
          <Grid item xs={12}>
            <Typography className={classes.sectionTitle}>Docentes Asignados</Typography>
            <Button variant="outlined" className={classes.addButton} onClick={() => { setModalTarget("teacher"); setOpenModalTeacher(true); }}>Añadir Docente</Button>
            <Box mt={2}>
              <GridComponent 
                dataSource={assignedTeachers} 
                allowPaging 
                pageSettings={{ pageSize: 5 }}
                columns={columnsTeachers}
              >
                <Inject services={[Page, Search, Toolbar]} />
              </GridComponent>
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Typography className={classes.sectionTitle}>Estudiantes Asignados</Typography>
            <Button variant="outlined" className={classes.addButton} onClick={() => { setModalTarget("student"); setOpenModalStudent(true); }}>Añadir Estudiante</Button>
            <Box mt={2}>
               <GridComponent 
                dataSource={assignedStudents} 
                allowPaging 
                pageSettings={{ pageSize: 12 }}
                columns={columnsStudents}
              >
                  <Inject services={[Page, Search, Toolbar]} />
               </GridComponent>
            </Box>
          </Grid>

          <Grid item xs={12} style={{ textAlign: "right" }}>
            <Button variant="contained" color="primary" size="large" onClick={handleSave} disabled={loading} className={classes.button}>
              {params.id ? "Actualizar Grupo" : "Crear Grupo"}
            </Button>
          </Grid>
        </Grid>
      </Paper>

      <Dialog open={openModalTeacher || openModalStudent} onClose={() => { setOpenModalStudent(false); setOpenModalTeacher(false); }} fullWidth maxWidth="sm">
        <DialogTitle>{modalTarget === "student" ? "Buscar Estudiante" : "Buscar Docente"}</DialogTitle>
        <DialogContent>
          <Autocomplete
            options={searchResults}
            getOptionLabel={(o) => `${o.documento} - ${o.nombres} ${o.apellidos}`}
            renderInput={(p) => <TextField {...p} label="Nombre o Documento" variant="outlined" />}
            onInputChange={(e, v) => searchUsers(v, modalTarget === "student" ? 5 : 4, setSearchResults)}
            onChange={(e, v) => setForm({ 
              ...form, 
              [modalTarget === "student" ? "id_estudiantes" : "id_docentes_list"]: v?.id || "",
              [modalTarget === "student" ? "student_selected" : "teacher_selected"]: v || null
            })}
          />
          <Box mt={2}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel>Periodo</InputLabel>
              <Select value={modalTarget === "student" ? form.modal_period : form.id_periodos_docentes} onChange={(e) => setForm({ ...form, [modalTarget === "student" ? "modal_period" : "id_periodos_docentes"]: e.target.value })} label="Periodo">
                {periods.map(p => <MenuItem key={p.id} value={p.id}>{p.nombre}</MenuItem>)}
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setOpenModalStudent(false); setOpenModalTeacher(false); }}>Cancelar</Button>
          <Button variant="contained" color="primary" onClick={(e) => { if (modalTarget === "student") addAssignedStudent(e); else addAssignedTeacher(e); setOpenModalStudent(false); setOpenModalTeacher(false); }} disabled={modalTarget === "student" ? !form.student_selected || !form.modal_period : !form.teacher_selected || !form.id_periodos_docentes}>Añadir</Button>
        </DialogActions>
      </Dialog>
      <Backdrop loading={loadingDetail || loading} />
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  paper: { margin: theme.spacing(2, 2), padding: theme.spacing(4), display: "flex", flexDirection: "column", alignItems: "center" },
  container: { width: "100%" },
  button: { margin: "1em", padding: "1em 4em", borderRadius: "12px", backgroundColor: "#9d2d39", color: "white", "&:hover": { backgroundColor: "#82242e" } },
  sectionTitle: { width: "100%", fontWeight: "bold", color: "#9d2d39", borderLeft: "5px solid #9d2d39", paddingLeft: "15px", marginBottom: "15px" },
  addButton: { borderRadius: "8px", border: "1px solid #9d2d39", color: "#9d2d39" },
}));

const mapStateToProps = (state) => ({
  userId: state.user?.id,
  token: state.token,
  rawPermissions: state.permission,
});
export default connect(mapStateToProps, { setBreadcrumps })(FormGradeGroups);
